import { Box, Drawer, SxProps } from '@mui/material';
import { AppBar } from 'components/AppBar/AppBar';
import React from 'react';
import { Outlet } from 'react-router-dom';
import { NavDrawerButton } from 'components/NavDrawerButton/NavDrawerButton';
import { MarketplaceNav } from '../MarketplaceNav/MarketplaceNav';

const NAV_WIDTH = '200px';

const styles: Record<string, SxProps> = {
  desktopNav: {
    width: NAV_WIDTH,
    flexShrink: 0,
    '& .MuiDrawer-paper': {
      width: NAV_WIDTH,
      bgcolor: 'background.default',
      borderRight: 'none',
      p: 0,
    },
    display: {
      xs: 'none',
      sm: 'block',
    },
  },
  mobileNav: {
    display: {
      xs: 'block',
      sm: 'none',
    },
  },
  header: {
    left: {
      xs: 0,
      sm: NAV_WIDTH,
    },
  },
  main: {
    paddingLeft: {
      xs: 0,
      sm: NAV_WIDTH,
    },
  },
  wrapper: {
    padding: {
      xs: '8px 16px 16px 16px',
    },
  },
};

export function MarketplaceLayout() {
  const [mobileNavDrawerOpen, setMobileNavDrawerOpen] = React.useState(false);

  function toggleMobileNavDrawer() {
    setMobileNavDrawerOpen(!mobileNavDrawerOpen);
  }

  const navButton = (
    <NavDrawerButton
      setDrawerOpen={setMobileNavDrawerOpen}
      drawerOpen={mobileNavDrawerOpen}
      sx={{ display: { xs: 'flex', sm: 'none' } }}
    />
  );

  return (
    <>
      <Drawer variant='permanent' sx={styles.desktopNav}>
        <MarketplaceNav />
      </Drawer>

      <Drawer open={mobileNavDrawerOpen} onClose={toggleMobileNavDrawer} sx={styles.mobileNav}>
        <MarketplaceNav />
      </Drawer>

      <AppBar showLogo={false} navButton={navButton} sx={styles.header} />

      <Box component='main' sx={styles.main}>
        <Box sx={styles.wrapper}>
          <Outlet />
        </Box>
      </Box>
    </>
  );
}
